import React, { useState, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-toastify/dist/ReactToastify.css';
import { Formik, Form } from "formik";
import Yup from '../../../../util/Validacoes';
import { mostrarToast } from '../../../../components/Toasts'
import { useParams } from "react-router-dom";
import { get, salvar } from '../../../../util/AcessoApi'
import { HeaderCadastro } from '../../../../components/Headers'
import { Link } from 'react-router-dom'
import { InputDateTimePicker, InputPadrao, InputSwitch, TextArea } from '../../../../components/Inputs'
import { InputSimNao } from '../../../../components/InputsAutoComplete'
import { BotaoPadrao } from '../../../../components/Botoes'
import { mensagens } from '../../../../util/Utilitarios'
import '../../../../assets/css/icones/iconsmind/style.css'
import Atalho from '../../../../util/Atalho'
import { ACOES } from '../../../../util/Enums'

const CadastroModalDevolucao = (props) => {

    let { id } = useParams()

    const [salvarENovo, setSalvarENovo] = useState(false)
    const [salvando, setSalvando] = useState(false)
    const [valoresIniciais, setValoresIniciais] = useState({})
    const [validacao] = useState(Yup.object({
        data_devolucao: Yup.string().nullable().required().trim().max(200),
        responsavel: Yup.string()
    }))

    const Submit = (values, propsFormik) => {
        values.id = props.propsAcao.id
        values.devolvido = true
        setSalvando(true)
        salvar(
            values,
            '/devolucao/entrega',
            (obj) => {
                props.funcaoAposSalvar()
                mostrarToast('sucesso', mensagens.sucesso)
                propsFormik.resetForm({})
                setSalvando(false)
            },
            () => {
                setSalvando(false)
            },
            null, 
            ACOES.DEVOLUCAO_LOTE)
    }

    // useEffect(() => {
    //     setValoresIniciais({
    //         descricao: null
    //     })
    // }, [])

    return (
        <Formik
            initialValues={valoresIniciais}
            validationSchema={validacao}
            enableReinitialize={true}
            onSubmit={(values, propsFormik) => { Submit(values, propsFormik) }}>
            {propsFormik => (<Form>
                <div className={props.modal && props.modal || 'card mb-20'}>
                    <div className={props.modal || 'card-body'}>
                        <div className='row'>
                            <InputPadrao label='Id' name='id' type='hidden' placeholder='Id' obrigatorio={false} />
                            <InputDateTimePicker autoFocus classeTooltip={props.modal && 'tooltip-input-modal'} tamanho={!props.modal && "col-lg-4 col-md-7"}
                                label="Data" name="data_devolucao" type="text" obrigatorio="true" setarValor={value => {
                                    propsFormik.setFieldValue("data_devolucao", value)
                                }} salvarENovo />
                            <InputPadrao label='Nome Responsável' propsFormik={propsFormik} quebrarLinha classeDiv='form-group ' name='responsavel' size="md" tamanho={!props.modal && 'col-lg-1'} classeTooltip={props.modal && 'tooltip-input-modal'} />
                            <Atalho formik={propsFormik} salvando={salvando} setSalvareNovo={setSalvarENovo} salvarENovo={true} />
                        </div>
                    </div>
                </div>
                {!props.modal ? <div className='separator mt-40 mb-5'></div> : <></>}
                <div className='direita container-botoes mb-3 group-salvar-novo'>
                    <BotaoPadrao texto='Salvar' disabled={salvando} click={_ => setSalvarENovo(false)} idTooltip={'salvar'} />
                    {/* {!id && <BotaoPadrao texto='Salvar e Novo' disabled={salvando} click={_ => setSalvarENovo(true)} idTooltip={'salvarENovo'} />} */}
                </div>
            </Form>)
            }
        </Formik >
    );
}

const CadastroCancelamentoDevolucao = (props) => {
    let { id } = useParams()

    const [salvarENovo, setSalvarENovo] = useState(false)
    const [salvando, setSalvando] = useState(false)
    const [valoresIniciais, setValoresIniciais] = useState({ motivo_cancelamento: '' })
    const [validacao] = useState(Yup.object({
        motivo_cancelamento: Yup.string().nullable().required()
    }))

    const Submit = (values, propsFormik) => {
        values.id = props.propsAcao.id
        setSalvando(true)
        salvar(
            values,
            '/devolucao/cancelamento',
            (obj) => {
                props.funcaoAposSalvar();
                mostrarToast('sucesso', mensagens.sucesso)
                propsFormik.resetForm({})
                props.setShow(false)
                setSalvando(false);
            },
            () => {
                setSalvando(false)
            },
            null, 
            ACOES.CANCELAMENTO_LOTE)
    }

    return (
        <Formik
            initialValues={valoresIniciais}
            validationSchema={validacao}
            enableReinitialize={true}
            onSubmit={(values, propsFormik) => { Submit(values, propsFormik) }}>
            {propsFormik => (<Form>
                <div className={props.modal && props.modal || 'card mb-20'}>
                    <div className={props.modal || 'card-body'}>
                        <div className='row'>
                            <TextArea obrigatorio={true} label='Motivo Cancelamento' name='motivo_cancelamento' type='text' placeholder='Motivo Cancelamento' tamanho={!props.modal && 'col-lg-12'} rows={2}
                                classeTooltip={props.modal && 'tooltip-input-modal'} />
                            {/* <TextArea label='Nome Responsável' propsFormik={propsFormik} quebrarLinha classeDiv='form-group ' name='responsavel' size="md" tamanho={!props.modal && 'col-lg-1'} classeTooltip={props.modal && 'tooltip-input-modal'} /> */}
                            <Atalho formik={propsFormik} salvando={salvando} setSalvareNovo={setSalvarENovo} salvarENovo={true} />
                        </div>
                    </div>
                </div>
                {!props.modal ? <div className='separator mt-40 mb-5'></div> : <></>}
                <div className='direita container-botoes mb-3 group-salvar-novo'>
                    <BotaoPadrao texto='Salvar' disabled={salvando} click={_ => setSalvarENovo(false)} idTooltip={'salvar'} />
                </div>
            </Form>)
            }
        </Formik >
    );
}

const Cadastro = (props) => {
    const links = [
        () => <Link to={'/dashboard'}>Dashboard</Link>,
        () => <Link to={'#'}>Administrativo</Link>,
        () => <Link className="link-active" to={'/parametros/cbos/consulta'}>Tipo Produto</Link>,
    ]
    return (<>
        {!props.modal && <HeaderCadastro titulo={"Cadastro de Tipo Produto"} link={links} />}
        <CadastroModalDevolucao {...props} />
    </>
    )
}
export { CadastroModalDevolucao, CadastroCancelamentoDevolucao }
export default Cadastro
